import {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {Alert, Button, Card, Col, Row} from "react-bootstrap";
import {Trash} from "react-bootstrap-icons";
import FormRepeater from "../../../../../../../common/FormReapeater.jsx"
import ButtonWithIcon from "../../../../../../../common/ButtonWithIcon.jsx";
import InputWiz from "../../../../../../../common/inputs/wizard/InputWiz.jsx";
import {useRegon} from "../../../../../../../../api/domain/regon/queries/useRegon.jsx";
import {toast} from 'react-toastify'

const PartnerRow = ({wiz, row, setRow, idx, remove, parent}) => {
    const regonValue = row?.partner_regon || ''
    const normalizedRegonValue = regonValue?.toString().trim()
    const regonTest = useRegon(regonValue, 'test')
    const regonData = useRegon(regonValue, 'data')
    const [regonState, setRegonState] = useState({
        checked: '',
        exists: false,
        ownerEmail: '',
        loading: false,
        error: '',
        missingPhone: false,
        missingEmail: false,
    })

    useEffect(() => {
        setRegonState((prev) => ({
            ...prev,
            checked: '',
            exists: false,
            ownerEmail: '',
            error: '',
            missingPhone: false,
            missingEmail: false,
        }))
    }, [regonValue])

    const resolveErrorMessage = (errors) => {
        if (!errors) return ''
        if (Array.isArray(errors?.regon)) return errors.regon[0]
        if (errors?.regon) return errors.regon
        if (Array.isArray(errors?.identyfikator)) return errors.identyfikator[0]
        if (errors?.identyfikator) return errors.identyfikator
        if (typeof errors === 'string') return errors
        return ''
    }

    const handleRegonTest = async () => {
        const regon = regonValue?.toString().trim()
        if (!regon) return
        setRegonState((prev) => ({...prev, loading: true}))
        const res = await regonTest.refetch()
        const data = res?.data
        const errorMessage = resolveErrorMessage(data?.errors)

        if (data?.status === 'failed' && data?.list?.length) {
            setRegonState({
                checked: regon,
                exists: false,
                ownerEmail: data?.list?.[0]?.email_wlasciciela || '',
                loading: false,
                error: '',
                missingPhone: false,
                missingEmail: false,
            })
            return
        }

        if (errorMessage) {
            toast.error(errorMessage)
            setRegonState({
                checked: regon,
                exists: false,
                ownerEmail: '',
                loading: false,
                error: errorMessage,
                missingPhone: false,
                missingEmail: false,
            })
            return
        }

        toast.success('REGON zweryfikowany pozytywnie.')
        setRegonState({
            checked: regon,
            exists: false,
            ownerEmail: '',
            loading: false,
            error: '',
            missingPhone: false,
            missingEmail: false,
        })
    }

    const handleRegonFetch = async () => {
        const regon = regonValue?.toString().trim()
        if (!regon) return
        setRegonState((prev) => ({...prev, loading: true}))
        const res = await regonData.refetch()
        const data = res?.data

        if (data?.status === 'success' && data?.list?.length) {
            const item = data.list[0]
            const nextForm = {
                ...wiz.form,
                [parent]: [...(wiz.form?.[parent] || [])],
            }
            nextForm[parent][idx] = {
                ...(nextForm[parent]?.[idx] || {}),
                partner_nazwa: item?.nazwa || '',
                partner_telefon: item?.telefon || '',
                partner_email: item?.email || '',
            }
            wiz.setWizForm(nextForm)
            setRegonState((prev) => ({
                ...prev,
                checked: regon,
                exists: false,
                ownerEmail: '',
                error: '',
                missingPhone: !item?.telefon,
                missingEmail: !item?.email,
            }))
        }

        setRegonState((prev) => ({...prev, loading: false}))
    }

    const canFetch =
        normalizedRegonValue &&
        regonState.checked === normalizedRegonValue &&
        !regonState.exists &&
        !regonState.error

    // const showMissingPhone = regonState.missingPhone && !row?.partner_telefon?.toString().trim()
    // const showMissingEmail = regonState.missingEmail && !row?.partner_email?.toString().trim()

    return (
        <Card className={'d-flex flex-column gap-2 mb-3 w-100'} key={idx}>
            <Card.Header className={'d-flex justify-content-between align-items-center'}>
                <div className={'fw-bold'}>{`Partner ${idx+1}`}</div>
                <ButtonWithIcon
                    text={`Usuń partnera ${idx+1}`}
                    onClick={() => remove(idx)}
                    icon={<Trash/>}
                    variant={'danger'}
                    className={'mt-4 align-self-start ms-auto'}
                />
            </Card.Header>
            <Card.Body className={'p-3'}>
                <Row>
                    <Col xs={12} md={3}>
                        <InputWiz
                            wiz={wiz}
                            keyName={`${parent}.${idx}.partner_regon`}
                            row={row}
                            setRow={setRow}
                            idx={idx}
                            max={14}
                            label={`I.1.2.${idx+1}.1 REGON partnera`}
                        />
                    </Col>

                    <Col xs={12} md={3} className={'d-flex align-items-end'}>
                        <div className={'d-flex gap-1 mb-4'}>
                            <Button
                                size={'sm'}
                                variant={'info'}
                                disabled={regonState.loading || !normalizedRegonValue}
                                onClick={handleRegonTest}
                            >
                                Sprawdź REGON
                            </Button>
                            <Button
                                size={'sm'}
                                variant={'secondary'}
                                disabled={regonState.loading || !canFetch}
                                onClick={handleRegonFetch}
                            >
                                Pobierz z REGON
                            </Button>
                        </div>
                    </Col>

                    <Col xs={12} md={6}>
                        <InputWiz
                            wiz={wiz}
                            keyName={`${parent}.${idx}.partner_nazwa`}
                            row={row}
                            setRow={setRow}
                            idx={idx}
                            label={`I.1.2.${idx+1}.2 Nazwa partnera`}
                        />
                    </Col>
                </Row>
                {/*<Row>*/}
                {/*    <Col>*/}
                {/*        <InputWiz*/}
                {/*            wiz={wiz}*/}
                {/*            keyName={`${parent}.${idx}.partner_telefon`}*/}
                {/*            row={row}*/}
                {/*            setRow={setRow}*/}
                {/*            idx={idx}*/}
                {/*            label={`I.1.2.${idx+1}.3 Partner telefon`}*/}
                {/*        />*/}
                {/*        {showMissingPhone && (*/}
                {/*            <Alert variant={'warning'} className={'mt-1 mb-0'}>*/}
                {/*                W bazie REGON brak numeru telefonu. Uzupełnij pole ręcznie.*/}
                {/*            </Alert>*/}
                {/*        )}*/}
                {/*    </Col>*/}

                {/*    <Col>*/}
                {/*        <InputWiz*/}
                {/*            wiz={wiz}*/}
                {/*            keyName={`${parent}.${idx}.partner_email`}*/}
                {/*            row={row}*/}
                {/*            setRow={setRow}*/}
                {/*            idx={idx}*/}
                {/*            label={`I.1.2.${idx+1}.4 Partner email`}*/}
                {/*        />*/}
                {/*        {showMissingEmail && (*/}
                {/*            <Alert variant={'warning'} className={'mt-1 mb-0'}>*/}
                {/*                W bazie REGON brak adresu e-mail. Uzupełnij pole ręcznie.*/}
                {/*            </Alert>*/}
                {/*        )}*/}
                {/*    </Col>*/}
                {/*</Row>*/}

            </Card.Body>
        </Card>
    )
}

export const PartnerzyRepeater = (props) => {
    const parent = props.parentListName || 'partner_list'
    return (
        <FormRepeater
            value={props.wiz.form?.[parent] || []}
            onChange={(list) => props.wiz.setValue(parent, list)}
            length={JSON.stringify(props.wiz.form?.[parent] || []).split('').reduce((acc, ch) => acc + ch.charCodeAt(0), 0)}
            addButtonText="Dodaj partnera"
            hideNativeDelete
            form={(row, setRow, idx, remove) => (
                <PartnerRow
                    wiz={props.wiz}
                    row={row}
                    setRow={setRow}
                    idx={idx}
                    remove={remove}
                    parent={parent}
                />
            )}
        />
    )
}

PartnerzyRepeater.propTypes = {
    wiz: PropTypes.any.isRequired,
    parentListName: PropTypes.string,
}
export default PartnerzyRepeater
